export default {
  allActions: [],
  oneAnswer: {},
  answer: [],
  revisions: [],
  summary: {
    opened: 0,
    analysis: 0,
    transfered: 0,
    answered: 0,
    total: 0,
  },
  costumerTimeline: [],
  costumerNotifications: [],
  idAnswer: null,
  loading: true,
  page: 1,
  fromDetails: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/treatments/initialState.js